<template>
  <div id="app">
    <Cart/>
  </div>
</template>

<script>
import Cart from './components/Cart.vue'

export default {
  name: 'app',
  components: {
    Cart
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = window.base_uri+'/themes/venedor/css/global.css';
      this.$el.append(link)
    }

    const blockCartProducts = document.querySelectorAll('.ajax_cart_block_remove_link');
    for(let blockCartProduct of blockCartProducts) {
      blockCartProduct.addEventListener('click', evt => {
        const ids = evt.target.parentElement.parentElement.dataset.id.replace('cart_block_product_', '').split('_');
        const productId = parseInt(ids[0]);
        const productAttributeId = parseInt(ids[1]);
        this.$store.dispatch('products/REMOVE', {
          id: productId,
          id_attribute: productAttributeId
        })
      })
    }
  }
}
</script>
